const FORMAT_DATE = 'DD/MM/YYYY';
const FORMAT_DATE_TIME = 'DD/MM/YYYY HH:mm';
const FORMAT_DATE_T_START = 'YYYY-MM-DDT00:00:00Z';
const FORMAT_DATE_T_END = 'YYYY-MM-DDT23:59:59Z';

export {
    FORMAT_DATE,
    FORMAT_DATE_TIME,
    FORMAT_DATE_T_START,
    FORMAT_DATE_T_END
}